<template>
  <router-link v-if="type === 'link'" :class="linkClass">
    <slot />
  </router-link>
  <button v-else :class="linkClass">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'link',
    },
    block: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default',
    },
  },

  computed: {
    linkClass() {
      return `${this.block ? 'block' : 'inline-block'} ${this.variant}`;
    },
  },
};
</script>

<style scoped>
a.router-link-active {
  @apply text-gpx_terracotta-200 hover:text-gpx_terracotta-200;
}
.default {
  @apply hover:text-black/70;
}
.primary {
  @apply text-gpx_terracotta-100 hover:text-gpx_terracotta-200;
}
</style>
